import * as ROUTES from 'Router/routes';
import { LatestLoan } from 'hooks/webapi/useLatestLoan';
import { useLatestLoan } from 'hooks/webapi';
import { useNavigate } from 'react-router-dom';
import useSelektra from 'pages/SelektraPage/useSelektra';

const useConditionalNavigation = () => {
  const { latestLoan } = useLatestLoan();
  const { isSelektraPageRequired } = useSelektra();
  const navigate = useNavigate();

  const navigateToDashboard = (
    fetchedLatestLoan?: LatestLoan | null | undefined | void,
  ) => {
    const loanToCheck = fetchedLatestLoan || latestLoan;
    let dashboard = ROUTES.ACTIVE_LOAN;
    if (!loanToCheck) dashboard = ROUTES.REPEATED_LOAN;
    if (isSelektraPageRequired(loanToCheck)) dashboard = ROUTES.SELEKTRA_ROUTE;

    navigate(dashboard);
  };

  return { navigateToDashboard };
};

export default useConditionalNavigation;
